import i18n from '@/plugins/i18n'

const displayCase = [
    {
        categoryName: i18n.t('displayCase.categoryName.electronicLock'),
        catgItem:[
            {
                id: "CP-9349464342694786",
                catgImg:require("@/assets/img/goods/displayCase/electronicLk/miniatureElectronicLocks/微型电子锁 (1).jpg"),
                name: i18n.t('displayCase.electronicLock.miniatureLock'),
                text: i18n.t('displayCase.electronicLock.miniatureLockDescription')
            },
            {
                id: "CP-7446364826743786",
                catgImg:require("@/assets/img/goods/displayCase/electronicLk/弹力锁.png"),
                name: i18n.t('displayCase.electronicLock.smartEjectionLock'),
                text: i18n.t('displayCase.electronicLock.smartEjectionLockDescription')
            },
            {
                id: "CP-269482642454786",
                catgImg:require("@/assets/img/goods/displayCase/electronicLk/electronicLk_azcls.png"),
                name: i18n.t('displayCase.electronicLock.concealedMagneticLock'),
                text: i18n.t('displayCase.electronicLock.concealedMagneticLockDescription')
            }

        ]
    },
    {
        categoryName: i18n.t('displayCase.categoryName.cardReader'),
        catgItem:[
            {
                id: "CP-98269489464385274",
                // catgImg:require("@/assets/img/goods/displayCase/crdReader/crdReader_mz.png"),
                catgImg:require("@/assets/img/goods/displayCase/crdReader/cylindricalCardReader/圆柱形读卡器 (1).jpg"),
                name: i18n.t('displayCase.cardReader.cylindricalReader'),
                text: i18n.t('displayCase.cardReader.cylindricalReaderDescription')
            },
            {
                id: "CP-946744385274",
                catgImg:require("@/assets/img/goods/displayCase/crdReader/implicitCardReader/隐式安装读卡器 (1).jpg"),
                name: i18n.t('displayCase.cardReader.implicitReader'),
                text: i18n.t('displayCase.cardReader.implicitReaderDescription')
            },
            {
                id: "CP-968548532157896",
                // catgImg:require("@/assets/img/goods/displayCase/crdReader/allInOneCardReader/读卡器一体机斜面.png"),
                catgImg:require("@/assets/img/goods/displayCase/crdReader/allInOneCardReader/读卡一体机 (3).jpg"),
                name: i18n.t('displayCase.cardReader.allInOneReader'),
                text: i18n.t('displayCase.cardReader.allInOneReaderDescription')
            },

        ]
    },
    {
        categoryName: i18n.t('displayCase.categoryName.controller'),
        catgItem:[
            {
                id: "CP-326636566494474",
                catgImg: require("@/assets/img/goods/displayCase/controller/controller-danmen.png"),
                name: i18n.t('displayCase.controller.singleDoorController'),
                text: i18n.t('displayCase.controller.standardControllerDescription')
            },
            {
                id: "CP-726636566494474",
                catgImg: require("@/assets/img/goods/displayCase/controller/threeDoorController/三门控制器 (1).jpg"),
                name: i18n.t('displayCase.controller.threeDoorController'),
                text: i18n.t('displayCase.controller.standardControllerDescription')
            },
            {
                id: "CP-897546123547895",
                catgImg:require("@/assets/img/goods/displayCase/controller/sixDoorController/六门控制器 (4).jpg"),
                name: i18n.t('displayCase.controller.sixDoorController'),
                text: i18n.t('displayCase.controller.standardControllerDescription')
            },
            {
                id: "CP-744636566494474",
                // catgImg:require("@/assets/img/goods/displayCase/controller/tenDoorControllers/十门控制器.png"),
                catgImg:require("@/assets/img/goods/displayCase/controller/tenDoorControllers/十门控制器 (1).jpg"),
                name: i18n.t('displayCase.controller.tenDoorController'),
                text: i18n.t('displayCase.controller.tenDoorControllerDescription')
            },
        ]
    },
    {
        categoryName: i18n.t('displayCase.categoryName.powerSupply'),
        catgItem:[
            {
                id: "CP-542436434269826",
                // catgImg:require("@/assets/img/goods/displayCase/powerSupply/integratedPowerSupply/集成电源正面.png"),
                catgImg:require("@/assets/img/goods/displayCase/powerSupply/integratedPowerSupply/专用集成电源 (2).jpg"),
                name: i18n.t('displayCase.powerSupply.integratedPowerSupply'),
                text: i18n.t('displayCase.powerSupply.integratedPowerSupplyDescription')
            },
            {
                id: "CP-524482634269826",
                catgImg:require("@/assets/img/goods/displayCase/powerSupply/powerSupply_kaiguan.png"),
                name: i18n.t('displayCase.powerSupply.switchingPowerSupply'),
                text: i18n.t('displayCase.powerSupply.switchingPowerSupplyDescription')
            },

        ]
    },

]

export {
    displayCase
}
